import React from 'react';
import ShareBuild from './ShareBuild';
import PrintDesign from './PrintDesign';
import StackSummary from './StackSummary';

const ShareContainer = () => {
  return (
    <span className="sui-leading-7 sui-inline-flex">
      <ShareBuild isPackout />
      <PrintDesign />
      <StackSummary />
    </span>
  );
};

export default ShareContainer;
